import { render, staticRenderFns } from "./DisplaySettingBottomSheet.vue?vue&type=template&id=2c80a36f&scoped=true"
import script from "./DisplaySettingBottomSheet.vue?vue&type=script&lang=ts"
export * from "./DisplaySettingBottomSheet.vue?vue&type=script&lang=ts"
import style0 from "./DisplaySettingBottomSheet.vue?vue&type=style&index=0&id=2c80a36f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80a36f",
  null
  
)

export default component.exports